import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { FlatList } from "react-native";
import i18n from "@microdoing/shared/i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import OptionBar from "./Onboarding/OptionBar";
import {
  clickTopic,
  changeSignupProgress,
} from "@microdoing/shared/services/signup/actions";
import selectLanguage from "../../utils/selectLanguage";
import SignupBottom from "./SignupBottom";
import SignupHeader from "./SignupHeader";
import { Box, MainText, MainTitle } from "app/components/common";
import normalize from "app/utils/normalize";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { WebSignupTopics } from "./WebSignupTopics";
import FastImage from "react-native-fast-image";
import { SafeAreaView } from "react-native-safe-area-context";
const LongDarkLogo = require("./../../../assets/images/long-dark-logo.png");
class SignupTopics extends PureComponent {
  state = {
    isNotificationModalVisible: false,
  };

  componentDidMount = async () => {};

  keyExtractor = (item, index) => {
    return index.toString();
  };

  goNext = async () => {
    const {} = this.props;
    this.props.changeSignupProgress(this.props.progressRatio);

    return this.props.navigation.navigate("WeeklyGoal", {
      isComingFromSignup: true,
      isComingFromFirstAction: false,
    });
  };

  goBack = () => {
    this.props.navigation.goBack();
    this.props.changeSignupProgress(-this.props.progressRatio);
  };

  onClickTopic = topic => () => {
    this.props.clickTopic(topic);
  };

  isSelected = option => {
    return (
      this.props.userTopicChoices.findIndex(el => el.value === option.value) >
      -1
    );
  };

  renderOption = language => data => {
    const option = data.item;

    return (
      <Box
        marginTop={"s"}
        backgroundColor="neutral.white"
        borderColor="neutral.100"
        borderWidth={1}
        minHeight={normalize(70)}
        width="100%"
        borderRadius={normalize(8)}
        alignItems="center"
        justifyContent="center"
      >
        <OptionBar
          onPress={this.onClickTopic(option)}
          isSelected={this.isSelected(option)}
          text={selectLanguage({
            text: option?.title,
            language,
          })}
        />
      </Box>
    );
  };

  renderBody = () => {
    return (
      <>
        <FlatList
          keyboardShouldPersistTaps="always"
          style={{ marginTop: 10, marginBottom: 10 }}
          contentContainerStyle={{ paddingBottom: 25 }}
          data={this.props.topicOptions}
          extraData={[
            this.props.userTopicChoices,
            this.props.topicOptions,
            this.props.language,
          ]}
          horizontal={false}
          keyExtractor={this.keyExtractor}
          renderItem={this.renderOption(this.props.language)}
        />
        <MainText
          textAlign="center"
          marginTop="s"
          marginBottom="xs"
          color="brand.500"
          variant="l4-medium"
        >
          {i18n.t("goals-selected", {
            numberOfGoals: this.props.userTopicChoices?.length || 0,
          })}
        </MainText>
        <SignupBottom
          testID="signup-topics-next-button"
          isRequesting={this.props.requesting}
          onPressBack={this.goBack}
          onPressNext={this.goNext}
        />
      </>
    );
  };

  render() {
    if (isWebDesktop) {
      return (
        <Box
          flex={1}
          justifyContent="center"
          backgroundColor="neutral.white"
          paddingHorizontal="s"
        >
          <Box variant="webOnboarding" backgroundColor="neutral.white">
            <Box
              paddingLeft="webXXL"
              paddingTop={{ smallWeb: "l", webBig: "webXXL" }}
            >
              <FastImage
                resizeMode="contain"
                source={LongDarkLogo}
                style={{
                  height: normalize(16),
                  width: normalize(110),
                }}
              />
            </Box>
            <Box flex={1} alignItems="center">
              <Box flex={1} width={normalize(344)} marginVertical="m">
                {this.renderBody()}
              </Box>
            </Box>
          </Box>
        </Box>
      );
    }

    return (
      <Box variant="screenView" backgroundColor="neutral.white">
        <SafeAreaView style={{ flex: 1 }}>
          <SignupHeader />
          <MainText variant="l6-medium" textAlign="center" marginTop="m">
            <MainText variant="l6-bold">
              {i18n.t("signup-topics-first")}
            </MainText>
            {i18n.t("signup-topics-second")}
          </MainText>
          {this.renderBody()}
        </SafeAreaView>
      </Box>
    );
  }
}

const mapStateToProps = state => {
  const { language } = state.profileSettings;
  const {
    userTopicChoices,
    topicOptions,
    progress,
    progressRatio,
    stats,
    choice,
    choiceAvailable,
    firstName,
    lastName,
    birthDate,
    sex,
    manager,
    requesting,
    jobFunction,
    mbti,
  } = state.signup;
  const { appAccess } = state.user;
  return {
    userId: getUserId(state),
    appAccess,
    picture: state.user.picture,
    feelingEvolution: state.user.feelingEvolution,
    userTopicChoices: userTopicChoices || [],
    topicOptions,
    language,
    progress,
    progressRatio,
    stats,
    choice,
    choiceAvailable,
    firstName,
    lastName,
    birthDate,
    sex,
    manager,
    requesting,
    jobFunction,
    mbti,
  };
};

export default connect(mapStateToProps, {
  changeSignupProgress,
  clickTopic,
})(SignupTopics);
